// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1NR5_","boxTitle":"Qualiphy_boxTitle__1Sam9","box":"Qualiphy_box__1c2Wd","toggleWrap":"Qualiphy_toggleWrap__15DBF"};